<!-- 导读书目详情 -->
<template>
    <!-- 书目详情 -->
    <div class="guide-book-container">
        <div class="guide-head-container">
            <div class="guide-left-head-container" @click = backPage>
                <svg t="1766639305795" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="12595" width="28" height="28"><path d="M512 512m-465.454545 0a465.454545 465.454545 0 1 0 930.90909 0 465.454545 465.454545 0 1 0-930.90909 0Z" fill="#e6e6e6" p-id="12596"></path><path d="M512 1024C229.236364 1024 0 794.763636 0 512S229.236364 0 512 0s512 229.236364 512 512-229.236364 512-512 512zM443.904 515.258182l205.637818-205.637818a58.181818 58.181818 0 1 0-82.292363-82.292364l-246.830546 246.830545a58.181818 58.181818 0 0 0 2.606546 84.712728l244.31709 244.363636a58.181818 58.181818 0 1 0 82.292364-82.292364l-205.730909-205.730909z" fill="#0d55a4" p-id="12597" data-spm-anchor-id="a313x.search_index.0.i5.3a373a81dKtAXk" class="selected"></path></svg>
            </div>
            <div class="guide-right-head-container">书目详情</div>
        </div>
        <el-scrollbar class="form-list-container">
            <div class="book-base-info-container">
                <div class="book-part1-l">
                    <div class="book-info-item-auto" v-show="bookForm.bookVideo">
                        <span class="item-span">导读视频：</span>
                    </div>
                    <!-- 导读视频  -->
                    <div class="book-video-container" v-show="bookForm.bookVideo">
                        <video id="videoElement"
                               :poster="bookForm.bookVideo + '?x-oss-process=video/snapshot,t_1,m_fast'" preload="none"
                               controls="controls" style="width: 75%;height: 100%;"
                               controlsList="nodownload"
                               :src="bookForm.bookVideo"></video>
                    </div>
                    <div class="book-info-item-auto">
                        <span class="item-span">书籍名称：</span>{{bookForm.bookName}}
                    </div>
                    <div class="book-info-item-auto">
                        <span class="item-span">所属主题：</span>{{bookForm.bookItemName}}
                    </div>
                    <div class="book-info-item-auto">
                        <span class="item-span">学段年级：</span>{{bookForm.periodName}}•{{bookForm.bookGradeName}}
                    </div>
                    <div class="book-info-item-auto">
                        <span class="item-span">作者：</span>{{bookForm.bookAuthor}}
                    </div>
                    <div class="book-info-item-auto">
                        <span class="item-span">出版时间：</span>{{ timestampDate(bookForm.publishTime) }}
                    </div>
                    <div class="book-info-item-auto">
                        <span class="item-span">书籍简介：</span>
                    </div>
                    <div class="book-info-item-auto-80" title="书籍简介" style="text-indent: 30px">
                        {{bookForm.bookIntroduction}}
                    </div>
                    <div class="book-info-item-auto">
                        <span class="item-span">推荐理由：</span>
                    </div>
                    <div class="book-info-item-auto-80" title="推荐理由" style="text-indent: 30px">
                        {{bookForm.bookReason}}
                    </div>
                    <div class="book-info-item-auto">
                        <span class="item-span">书籍附件：</span>
                    </div>
                    <div class="b-file-info-container">
                        <div class="b-file-list">
                            <div class="b-file-item" v-for="item in fileList" :key="item">
                                <div class="b-file-title">{{item.fileName}}</div>
                                <div class="b-file-view" title="预览" v-if="!judgeIsPPT(item.fileType)">
                                    <el-image @click="handleFIleStatus(item.status)" class="b-file-icon" style="margin-top: 5px"
                                              :src="require('@/assets/file/file_view.png')"
                                              :preview-src-list="gainFileImgList(item.imgUrl,item.pages)">
                                    </el-image>
                                </div>
                                <div class="b-file-view" title="播放" v-if="judgeIsPPT(item.fileType)">
                                    <el-image @click="viewPPTFile(item.fileUrl)" class="ppt-file-icon" style="margin-top: 5px"
                                              :src="require('@/assets/file/ppt_play.png')">
                                    </el-image>
                                </div>
                                <div class="b-file-download" title="下载">
                                    <img class="b-file-icon" @click="downloadFile(item)" style="margin-top: 3px" src="../../../assets/file/file_download.png" alt="">
                                </div>
                            </div>
                            <div v-if="fileList.length===0" class="data-empty">
                                <div class="empty-icon"><img src="../../../assets/icon/img/data_empty.png" /></div>
                                <div class="empty-title">暂无附件</div>
                            </div>
                        </div>



                    </div>
                </div>
                <div class="book-part1-r">
                    <div class="book-info-item-auto">
                        <span class="item-span">书目封面：</span>
                    </div>
                    <div class="book-base-info-cover">
                        <img class="img-100"  :src="bookForm.bookCover" alt="">
                    </div>
                </div>
            </div>
        </el-scrollbar>
    </div>
</template>
<script>
import {timestampDate} from "@/utils/date";
import {infoBook} from "@/api/admin/museum.js";
import {downloadFile} from "@/api/adminservice/public";

export default {
    name:'readBookInfo',
    components:{},
    props:{
        markInfo:{
            type: String,
            default:null
        },
        itemId:{
            type: String,
            default:null
        },
    },
    watch:{
        markInfo(newValue,oldValue){
            this.showMode = 'pageSub';
        },
        itemId(newValue,oldValue){
            this.bookId = newValue;
            this.queryBookInfo();
        },
    },
    mounted() {
    },
    data() {
        return {
            bookId:'',
            bookForm:{},  //数据
            timestampDate,
            fileList:[],
        }
    },
    methods: {
        queryBookInfo(){
            infoBook({ bookId: this.bookId }).then(res => {
                if (res.data.code === 1) {
                    this.bookForm = res.data.data;
                    this.fileList = this.bookForm.fileList;
                }else {
                    this.$message.error("操作失败")
                }
            });
        },
        backPage(){
            this.$emit('back-book-page', 'readMuseum');
        },
        viewFile(file){},
        viewPPTFile(fileUrl){
            const openUrl = 'https://ow365.cn/?i=36735&ssl=1&furl=' +fileUrl;
            window.open(openUrl, '_blank')
        },
        judgeIsPPT(fileType){
            if (!fileType){
                return false;
            }
            return fileType.toLowerCase().includes("ppt");
            // return false;
        },
        downloadFile(item){
            downloadFile(item.fileUrl, item.fileName)
        },
        handleFIleStatus(status){
            if (status === 1) {
            }else {
                this.$message.info("文件正在处理，请稍后刷新预览")
            }
        },
        gainFileImgList(baseUrl,page,){
            const list = [];
            for (let i = 1; i <=page ; i++) {
                list.push(baseUrl+'/' + i+'.png?'+new Date());
            }
            return list;
        },
    }
}
</script>
<style scoped>
.guide-book-container{
    width: 100%;
    height: calc(100vh - 174px);
    background: #ffffff;
    border-radius: 16px;
    padding: 20px 28px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
}
.guide-head-container{
    flex-shrink: 0;
    width: 100%;
    height: 44px;
    display: flex;
}
.guide-left-head-container{
    width: 80px;
    height: 44px;
    cursor: pointer;
    padding-left: 10px;
    padding-top: 9px;
    display: flex;
}
.guide-right-head-container{
    width: calc(100% - 160px);
    height: 44px;
    text-align: center;
    font-size: 18px;
    color: #0d55a4;
    line-height: 44px;
    font-weight: bold;
}

.form-list-container{
    flex: 1;
    min-height: 0;
    width: 100%;
    padding: 0;
    box-sizing: border-box;
}
.book-base-info-container{
    width: 100%;
    height: auto;
    padding-bottom: 10px;
    display: flex;
}
.book-part1-l{
    width: calc(100% - 220px);
    height: 100%;
    padding-right: 20px;
    box-sizing: border-box;
}
.book-info-item-auto{
    width: 100%;
    height: auto;
    line-height: 25px;
    display: flex;
    font-size: 15px;
    margin-top: 5px;
}
.book-info-item-auto-80{
    width: 95%;
    height: auto;
    line-height: 25px;
    display: flex;
    font-size: 15px;
    margin-top: 5px;
}
.book-part1-r{
    width: 220px;
    height: 100%;
}
.book-base-info-cover{
    width: 210px;
    height: 297px;
    box-sizing: border-box;
    img{
        width: 100%;
        height: 100%;
    }
}
.item-span{
    font-weight: bold;
    color: #0d55a4;
}
.book-video-container{
    width: 100%;
    height: auto;
}

.b-file-info-container{
    width: 100%;
    height: auto;
}
.b-file-list{
    width: calc(100% - 60px);
    height: auto;
}
.b-file-item{
    display: flex;
    height: 30px;
    width: 100%;
    box-sizing: border-box;
    border-bottom: 2px solid #a7a7a7;
}
.b-file-item:hover{
    color: #0d55a4!important;
    font-weight: bold;
    border-bottom: 2px solid #0d55a4!important;
}
.b-file-title{
    width: calc(100% - 60px);
    height: 100%;
    font-size: 15px;
    line-height: 30px;
    cursor: pointer;
}
.b-file-view{
    width: 30px;
    height: 100%;
}
.b-file-download{
    width: 30px;
    height: 100%;
}
.b-file-icon{
    width: 20px;
    height: 20px;
    cursor: pointer;
}
.ppt-file-icon{
    width: 20px;
    height: 18px;
    cursor: pointer;
}
</style>